import { DateTime } from 'luxon';
import React from 'react'
import { Table, Button } from 'reactstrap'
import history from '../../../../history';
import { auditMetricsForCompare, auditCaseStudyMetrics, smbAuditCaseStudyMetrics, getColorByComparison, LATEST_AUDIT_VERSION, ecommerceAuditCaseStudyMetrics, standardAuditCaseStudyMetrics, franDevCaseStudyV3, ecomAuditCaseStudyMetrics, auditVariance } from '../../../utils/Audits'

function AuditTable({audits, onLoadMoreAudits, allLoaded }){
    const onAuditRowClick = auditId => {
        history.push(`/audit/${auditId}`)
    }

    return <div id="auditTable"><Table striped responsive>
        <thead>
            <tr>
                <th>Date Created</th>
                <th>Period</th>
                <th>Audit Score</th>
                <th>Status</th>
            </tr>
        </thead>
        <tbody>
            {audits.length > 0 ? <>{audits.map(audit => {
                let metrics = audit.metrics
                if(audit.version === LATEST_AUDIT_VERSION){
                    metrics = audit.prevMetrics
                }

                const scores = Object.keys(metrics).reduce((prev, curr) => {
                    let caseStudy = auditCaseStudyMetrics
                    if(["standard"].includes(audit.type) && audit.version === LATEST_AUDIT_VERSION){
                        caseStudy = standardAuditCaseStudyMetrics
                    }
                    else if(["frandevNew"].includes(audit.type) && audit.version === LATEST_AUDIT_VERSION){
                        caseStudy = franDevCaseStudyV3
                    }
                    else if(["ecommerce"].includes(audit.type) && audit.version === LATEST_AUDIT_VERSION){
                        caseStudy = ecomAuditCaseStudyMetrics
                    }
                    else if(["veteranstats","smbstats"].includes(audit.type) && audit.version === 2) {
                        caseStudy = smbAuditCaseStudyMetrics
                    }
                    else if(["ecommercestats"].includes(audit.type) && audit.version === 2) {
                        caseStudy = ecommerceAuditCaseStudyMetrics
                    }
                    
                    if(auditMetricsForCompare[curr] && 
                        (auditMetricsForCompare[curr].typesDisabled === undefined || 
                            !auditMetricsForCompare[curr].typesDisabled.includes(audit.type))) {
                        let score = 0   
                        let _ = null

                        if(audit.version === LATEST_AUDIT_VERSION){
                            [_, score] = getColorByComparison(
                                audit.prevMetrics ? (audit.prevMetrics[curr] ?? 0) : 0, 
                                audit.metrics[curr], 
                                auditMetricsForCompare[curr].opposite, 
                                auditVariance[curr] ? auditVariance[curr] : 0,
                                auditMetricsForCompare[curr].scoreToBaselineOverride
                            )            
                        } else{
                            [_, score] = getColorByComparison(audit.metrics[curr], caseStudy[curr], auditMetricsForCompare[curr].opposite)
                        }
                        if(!auditMetricsForCompare[curr].excludeFromScore || 
                            (Array.isArray(auditMetricsForCompare[curr].excludeFromScore) && 
                            !auditMetricsForCompare[curr].excludeFromScore.includes(audit.type))){
                            prev.total += score
                            prev.divide += 1
                        }
                    }
                    
                    
                    return prev
                }, {
                    total: 0,
                    divide: 0
                })
                let auditScorePercent = parseInt(Math.round(scores.total / scores.divide * 100))

                return <tr key={audit.auditId} className="hover" onClick={() => onAuditRowClick(audit.auditId)}>
                    <td>{DateTime.fromMillis(audit.timestamp).toFormat("LLL d, yyyy")}</td>
                    <td>{audit.yearMonth ? DateTime.fromFormat(audit.yearMonth.toString(), "yyyyMM").toFormat("LLL yyyy") : ""}</td>
                    <td>
                        {["ecommercestats"].includes(audit.type) ? "click to see" : auditScorePercent + "%"}
                    </td>
                    <td>{audit.status}</td>
                </tr>
            })}

            {!allLoaded && <tr>
                <td colSpan="100%" className="text-center">
                    <Button color="primary" outline onClick={() => onLoadMoreAudits()}>Load More</Button>
                </td>
            </tr>}
            </> : <tr><th colSpan="100%" className="text-center">There are no rows</th></tr>}
        </tbody>
    </Table></div>
}

AuditTable.defaultProps = {
    audits: []
}

export default AuditTable